import { useContext, useEffect, useState } from "react";
import { useService } from "../../../../hooks";
import { AppContext } from "../../../../context";

export const useProjectList = () => {
  const { fetchByAttr } = useService("Data", "project");
  const commonPageSize = 5;
  const { setTitle } = useService("Meta");
  const { isBottom } = useService("Misc");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const [projectList, setprojectList] = useState([]);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [filteredList, setfilteredList] = useState([]);

  setTitle("Project");
  useEffect(() => {
    getProjectsData();
    document.addEventListener("scroll", trackScrolling);
    return () => {
      document.removeEventListener("scroll", trackScrolling);
    };
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const getProjectsData = async () => {
    const result = await fetchByAttr({ status: "publish" });
    if (result.status) {
      let projectData = result.data;
      setprojectList(projectData);
      setfilteredList(projectData);
    }
  };
  return {
    activeShownTotal,
    projectList,
  };
};
